import BeardItemCard from "./BeardItemCard"
import Loading from "~/components/Loading";

export default function BeardFlightsList({ items = [], unviewed = [], itemsEmpty = [] }) {
    
    function handleAction(e, item, action) {
        e.preventDefault();

        if (action.slice(0, 1) === '/') window.location = action;
        if (action === 'view') window.location = `/flights/${item.id}`;
        if (action === 'data') window.location = `/flights/data/${item.id}`;
    }

    return <React.Fragment>
        {items.length > 0 && items.map(item => <BeardItemCard key={`${item.id}-${item.code}`} item={item} isNew={unviewed.includes(item.id)} onActionPress={handleAction} />)}
        {items.length === 0 && itemsEmpty.map(item => <BeardItemCard key={`${item.id}-${item.code}`} item={item} onActionPress={handleAction} />)}
    </React.Fragment>
}
